/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Action } from '@ngrx/store';
import { LicenseClass, Vehicle } from '@shared/models';

export const INIT = '[Vehicles] Init';
export const LOAD_VEHICLES = '[Vehicles] Load';
export const LOAD_VEHICLES_SUCCESS = '[Vehicles] Load success';
export const LOAD_VEHICLES_FAILURE = '[Vehicles] Load failure';
export const LOAD_VEHICLE = '[Vehicle] Load';
export const LOAD_VEHICLE_SUCCESS = '[Vehicle]Load success';
export const LOAD_VEHICLE_FAILURE = '[Vehicle] Load failure';
export const PERSIST_VEHICLE = '[Vehicle] Persist';
export const PERSIST_VEHICLE_SUCCESS = '[Vehicle] Persist success';
export const PERSIST_VEHICLE_FAILURE = '[Vehicle] Persist failure';
export const DEACTIVATE_VEHICLE = '[Vehicle] Deactivate';
export const DEACTIVATE_VEHICLE_SUCCESS = '[Vehicle] Deactivate success';
export const DEACTIVATE_VEHICLE_FAILURE = '[Vehicle] Deactivate failure';
export const LOAD_LICENCE_CLASSES = '[Vehicles] Load licence classes';
export const LOAD_LICENCE_CLASSES_SUCCESS = '[Vehicles] Load licence classes success';
export const LOAD_LICENCE_CLASSES_FAILURE = '[Vehicles] Load licence classes failure';

export class Init implements Action {
  readonly type = INIT;
  constructor(public licenceClasses: LicenseClass[]) { }
}

export class LoadVehicles implements Action {
  readonly type = LOAD_VEHICLES;
}

export class LoadVehiclesSuccess implements Action {
  readonly type = LOAD_VEHICLES_SUCCESS;
  constructor(public vehicles: Vehicle[]) { }
}

export class LoadVehiclesFailure implements Action {
  readonly type = LOAD_VEHICLES_FAILURE;
}

export class LoadVehicle implements Action {
  readonly type = LOAD_VEHICLE;
  constructor(public vehicleId?: string) { }
}

export class LoadVehicleSuccess implements Action {
  readonly type = LOAD_VEHICLE_SUCCESS;
  constructor(public vehicle: Vehicle) { }
}

export class LoadVehicleFailure implements Action {
  readonly type = LOAD_VEHICLE_FAILURE;
}

export class PersistVehicle implements Action {
  readonly type = PERSIST_VEHICLE;
  constructor(public vehicle: Vehicle) { }
}

export class PersistVehicleSuccess implements Action {
  readonly type = PERSIST_VEHICLE_SUCCESS;
}

export class PersistVehicleFailure implements Action {
  readonly type = PERSIST_VEHICLE_FAILURE;
}

export class DeactivateVehicle implements Action {
  readonly type = DEACTIVATE_VEHICLE;
  constructor(public vehicle: Vehicle) { }
}

export class DeactivateVehicleSuccess implements Action {
  readonly type = DEACTIVATE_VEHICLE_SUCCESS;
  constructor(public vehicle: Vehicle) { }
}

export class DeactivateVehicleFailure implements Action {
  readonly type = DEACTIVATE_VEHICLE_FAILURE;
}

export class LoadLicenceClasses implements Action {
  readonly type = LOAD_LICENCE_CLASSES;
}

export class LoadLicenseClassesSuccess implements Action {
  readonly type = LOAD_LICENCE_CLASSES_SUCCESS;
  constructor(public licenceClasses: LicenseClass[]) { }
}

export class LoadLicenseClassesFailure implements Action {
  readonly type = LOAD_LICENCE_CLASSES_FAILURE;
}

export type VehicleActions =  Init | LoadVehicles | LoadVehiclesSuccess | LoadVehiclesFailure | LoadVehicle | LoadVehicleSuccess |
  LoadVehicleFailure | PersistVehicle | PersistVehicleSuccess | PersistVehicleFailure | LoadLicenceClasses | LoadLicenseClassesSuccess |
  LoadLicenseClassesFailure | DeactivateVehicle | DeactivateVehicleSuccess | DeactivateVehicleFailure;
